import { Auth0ContextInterface } from "@auth0/auth0-react/dist/auth0-context";
import { LogoutOptions } from "@auth0/auth0-spa-js";

let getAccessTokenSilently: any = null;
let logout: null | Auth0ContextInterface["logout"] = null;
let getUser: null | (() => Auth0ContextInterface["user"]) = null;

export const security = {
  getAccessTokenSilently: () => getAccessTokenSilently().catch(console.log),
  setAccessTokenSilently: (func: any) => {
    getAccessTokenSilently = func;
  },
  logout: (opions: LogoutOptions) => logout && logout(opions),
  setLogout: (func: Auth0ContextInterface["logout"]) => {
    logout = func;
  },
  /**
   * The signed-in user's Auth0 profile, for the AICC admin audit trail — `instance.ts` sends the
   * address as `X-Admin-User` so a published version names a person instead of `auth0|606d89…`.
   *
   * A GETTER rather than the object, because this module is read from an axios interceptor while the
   * value belongs to a React hook. `App.tsx` re-registers on every render, so the getter always
   * closes over the current user; storing the object here would freeze whoever was signed in first.
   */
  getUser: () => getUser?.(),
  setGetUser: (func: () => Auth0ContextInterface["user"]) => {
    getUser = func;
  },
};
